import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { z } from 'zod'
import { makeZodI18nMap } from 'zod-i18n-map'

import { resources } from '../locales/resources'
import { UserLanguages } from './types'

const availableLng = Object.keys(resources) as UserLanguages[]
const availableNs = Object.keys(
  resources[availableLng[0]]
) as (keyof (typeof resources)[(typeof availableLng)[0]])[]

void i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector) // detects user language in the browser
  .init({
    resources,
    supportedLngs: availableLng,
    ns: availableNs,
    fallbackLng: 'fr',
    returnEmptyString: false,
    returnNull: false,
    // Cannot use with ZODI18nMap
    // keySeparator: '~',
    defaultNS: 'common',
    debug: !import.meta.env.PROD,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
      transKeepBasicHtmlNodesFor: ['strong', 'i'],
    },
  })

z.setErrorMap(
  makeZodI18nMap({
    t: i18n.t,
    ns: ['zod'],
  })
)

export default i18n
